import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import IconButton from '@material-ui/core/IconButton';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

// COMPONENTS
import DialogMenuActions from '@/components/Dialogs/DialogMenuActions';

const ActionsMenu = ({ className, actions, ...props }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        className={clsx('actions-menu-button', className)}
        aria-label="more"
        aria-controls="actions-menu"
        aria-haspopup="true"
        onClick={handleClick}
        color="inherit"
        {...props}
      >
        <MoreHorizIcon fontSize="inherit" className="actions-menu__button-icon" />
      </IconButton>

      <DialogMenuActions
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        actions={actions}
      />
    </>
  );
};

ActionsMenu.defaultProps = {
  className: '',
};

ActionsMenu.propTypes = {
  className: PropTypes.string,
  actions: PropTypes.array.isRequired,
};
export default React.memo(ActionsMenu);
